import { Component, HostBinding, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'timesheet-content-row',
  host: {
    class: 'timesheet-content-row',
  },
  template: ` <ng-content></ng-content> `,
})
export class TimesheetContentRowComponent {
  @HostBinding('style.backgroundSize')
  backgroundSize: string;

  @HostBinding('class.timesheet-grid')
  @Input()
  grid = true;
}
